import { render, staticRenderFns } from "./shop_info.vue?vue&type=template&id=86b4ddc4&scoped=true"
import script from "./shop_info.vue?vue&type=script&lang=js"
export * from "./shop_info.vue?vue&type=script&lang=js"
import style0 from "./shop_info.vue?vue&type=style&index=0&id=86b4ddc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b4ddc4",
  null
  
)

export default component.exports